import { format as fmt } from 'date-fns';
import { ru } from 'date-fns/locale';

import { formatDate, FormatDateOptions } from '@libs/dates';

type CustomDateViewProps = {
  className?: string;
  date?: Date | string | number | null;
  format: string;
};
function CustomDateView({ className, date, format }: CustomDateViewProps) {
  const result = fmt(date || new Date(), format, { locale: ru });
  return <span className={className}>{result}</span>;
}

export type DateViewProps = {
  className?: string;
  date?: Date | string | number | null;
  humanReadableDay?: boolean;
  shortMonth?: boolean;
  year?: 'show' | 'hide' | 'notCurrent';
  showTime?: boolean;
  forceLeadingZero?: boolean;
  timezone?: 'current' | 'utc';
};
export function DateView({
  className,
  date,
  humanReadableDay = true,
  showTime,
  shortMonth,
  year = 'notCurrent',
  forceLeadingZero,
  timezone,
}: DateViewProps) {
  const options: FormatDateOptions = {
    humanReadableDay,
    showTime,
    shortMonth,
    year,
    forceLeadingZero,
    timezone,
  };

  if (!date) return null;

  return <span className={className}>{formatDate(date, options)}</span>;
}

export function TimeView({ className, date }: { className?: string; date?: Date | number | null }) {
  if (!date) return null;
  return <CustomDateView className={className} date={date} format="HH:mm" />;
}

export function YearView({ className, date }: { className?: string; date: Date | number }) {
  return <CustomDateView className={className} date={date} format="yyyy" />;
}
